import { Permission } from '@cims-online/shared'
import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { ConcreteMixDesign } from '../MixDesignsContext/types'
import { useConcreteMixDesignsContext } from '../MixDesignsContext'

export function useCustom(): CustomRowActionOptions<ConcreteMixDesign>[] {
  const { refetch, edit } = useConcreteMixDesignsContext()
  const setActive = async (globalId: string, active = true) => {
    await edit({ variables: { input: { globalId, active } } })
    refetch()
  }

  return [
    {
      text: 'Activate',
      permission: Permission.EditConcreteMixDesign,
      onClick: async ({ globalId }) => setActive(globalId),
      hidden: ({ active }) => active,
    },
    {
      text: 'Inactivate',
      permission: Permission.EditConcreteMixDesign,
      onClick: async ({ globalId }) => setActive(globalId, false),
      hidden: ({ active }) => !active,
    },
  ]
}
